import type { ServiceForSelectedServiceType } from '@common/interfaces/processStartWizard';
import { ServiceCode } from '@common/enums';
import { never } from '@common/utils/never';
import { translateKey } from '@frontend/translate';
import type { IServiceDataItem } from './getServiceData';

export function getServiceDataForPilot(
    service: ServiceForSelectedServiceType,
    serviceCode: ServiceCode.PILOT
): Partial<IServiceDataItem> {
    switch (serviceCode) {
        case ServiceCode.PILOT:
            return {
                title: `${service.name} ${translateKey(
                    service.isServiceProvider ? 'home.action_performSelf' : 'home.action_inquiry'
                )}`,
            };

        default:
            never(serviceCode);
    }
}
